import dashboard from './dashboard';
import auth from './auth';
import app from './app';
import queue from './queue';
import meeting from './meeting';
import callListener from './callListener';

export default { dashboard, auth, app, queue, meeting, callListener };
